
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import AuthGuard from '@/components/auth/AuthGuard';
import Header from '@/components/Header';
import MyListingsComponent from '@/components/property/MyListings';
import { useLanguage } from '@/contexts/LanguageContext';

const MyListings = () => {
  const { user, profile } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    if (profile && profile.role === 'student') {
      navigate('/search');
    }
  }, [profile, navigate]);

  if (profile?.role === 'student') {
    return (
      <div className="min-h-screen">
        <Header />
        <div className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-3xl font-bold mb-4">
            {t('access_denied', 'غير مسموح بالوصول', 'Access Denied')}
          </h1>
          <p className="text-lg text-muted-foreground mb-6">
            {t('landlord_only', 'هذه الصفحة متاحة للملاك فقط', 'This page is only available for landlords')}
          </p>
          <button
            onClick={() => navigate('/search')}
            className="bg-primary text-primary-foreground px-6 py-3 rounded-lg hover:bg-primary-hover"
          >
            {t('back_to_search', 'العودة للبحث', 'Back to Search')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <AuthGuard requireAuth={true}>
      <div className="min-h-screen bg-background">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-3xl font-bold mb-8">
              {t('my_listings', 'عقاراتي', 'My Listings')}
            </h1>
            <MyListingsComponent />
          </div>
        </div>
      </div>
    </AuthGuard>
  );
};

export default MyListings;
